export default __webpack_public_path__ + "static/media/prev-IVTS-6.b4194301.png";